import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetComplianceInvestigationActionOrInstructionDetailsAsync,
  IComplianceInvestigationActionOrInstructionDetails,
} from "../../api/ComplianceInvestigation/IComplianceInvestigationActionsAndInstructions";
import { RootState } from "../store";

export interface ActionOrInstructionState {
  fetchStatus: string;
  actionOrInstruction?: IComplianceInvestigationActionOrInstructionDetails;
}

const initialState: ActionOrInstructionState = {
  fetchStatus: "Loading...",
  actionOrInstruction: undefined,
};

export const loadActionOrInstructionAsync = createAsyncThunk(
  "actionOrInstruction/load",
  async (taskId: string) => {
    const response =
      await GetComplianceInvestigationActionOrInstructionDetailsAsync(taskId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const actionOrInstructionSlice = createSlice({
  name: "actionOrInstruction",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadActionOrInstructionAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadActionOrInstructionAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.actionOrInstruction = action.payload;
      });
  },
});

export const selectActionOrInstruction = (state: RootState) =>
  state.actionOrInstruction;

export default actionOrInstructionSlice.reducer;
